// extracted by mini-css-extract-plugin
export default {"weather":"style_weather__JFxh2","select":"style_select__4as8b","name":"style_name__x9FJr"};